import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

export const ButtonTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(({}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#F8F8F8",
        color: "#212529",
        borderBottomWidth: "3px",
        borderStyle: "solid",
        borderColor: "#00738A",
        fontFamily: "Armata, sans-serif",
        fontSize: "0.875rem",
        fontWeight: "400",
        padding: ".5rem .75rem",
        borderRadius: "0",
        boxShadow: "0 1px 3px rgba(0,0,0,.4)"
    }
}));
